import { render, staticRenderFns } from "./add-email-template.vue?vue&type=template&id=067dabaa"
import script from "./add-email-template.vue?vue&type=script&lang=js"
export * from "./add-email-template.vue?vue&type=script&lang=js"
import style0 from "./add-email-template.vue?vue&type=style&index=0&id=067dabaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports